import React from 'react';
import { observer } from 'mobx-react';

import { routeNode } from 'core/routing';

import { FourOhFour } from 'apps/fourOhFour/index';

import { StoryView } from 'apps/story/views/storyView';
import { StoryEdit } from 'apps/story/views/storyEdit';
import { StoryAppManager } from 'apps/story/main/appManager';
import PropTypes from 'prop-types';

const storyViewsMap = {
  '': StoryView,
  edit: StoryEdit,
};

@observer
class Story extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new StoryAppManager(null, this.props);
  }

  render() {
    if (this.appManager.notFound) {
      return <FourOhFour type='Story' />;
    }
    const View = this.props.componentFromRoute();
    return (
      <View
        params={this.props.routerStore.params}
        routeName={this.props.route.name}
        story={this.appManager.story}
        loading={this.appManager.loading}
      />
    );
  }
}

Story.propTypes = {
  route: PropTypes.object,
  routerStore: PropTypes.object,
  componentFromRoute: PropTypes.func,
};

export const ProfileStoryRouter = routeNode(
  'profile.story',
  storyViewsMap,
  FourOhFour,
)(Story);
export const InitiativeStoryRouter = routeNode(
  'initiative.story',
  storyViewsMap,
  FourOhFour,
)(Story);
